const Component = {
  render: function render() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      'div',
      [
        _c('h1', { staticClass: 'uk-h1 tm-heading-fragment' }, [
          _vm._v('Pagination')
        ]),
        _c('p', { staticClass: 'uk-text-lead' }, [
          _vm._v(
            'Easily create a nice looking pagination to navigate through pages.'
          )
        ]),
        _vm._v(' '),
        _vm._m(0),
        _vm._m(1),
        _vm._v(' '),
        _vm._m(2),
        _c('md-code-example-87'),
        _c(
          'p',
          [
            _c('vk-label', [_vm._v('Note')]),
            _vm._v(' In the demo we are setting the '),
            _c('code', [_vm._v('page')]),
            _vm._v(' prop with a '),
            _c(
              'a',
              {
                attrs: {
                  href:
                    'https://vuejs.org/v2/guide/components.html#sync-Modifier',
                  target: '_blank'
                }
              },
              [_vm._v('sync modifier')]
            ),
            _vm._v(
              ' to give the pagination the possibility to control the display.'
            )
          ],
          1
        ),
        _vm._v(' '),
        _c('hr', { staticClass: 'uk-margin-large' }),
        _vm._m(3),
        _vm._m(4),
        _vm._v(' '),
        _vm._m(5),
        _c('md-code-example-88'),
        _c('hr', { staticClass: 'uk-margin-large' }),
        _vm._m(6),
        _vm._m(7),
        _vm._v(' '),
        _vm._m(8),
        _vm._m(9),
        _c('md-code-example-89'),
        _c('hr', { staticClass: 'uk-margin-large' }),
        _vm._m(10),
        _vm._m(11),
        _vm._m(12),
        _vm._m(13),
        _vm._m(14)
      ],
      1
    )
  },
  staticRenderFns: [
    function() {
      var _vm = this
      var _h = _vm.$createElement
      var _c = _vm._self._c || _h
      return _c(
        'h2',
        { staticClass: 'uk-h2 tm-heading-fragment', attrs: { id: 'usage' } },
        [_c('a', { attrs: { href: '#usage' } }, [_vm._v('Usage')])]
      )
    },
    function() {
      var _vm = this
      var _h = _vm.$createElement
      var _c = _vm._self._c || _h
      return _c('p', [
        _vm._v('The '),
        _c('code', [_vm._v('vk-pagination')]),
        _vm._v(
          ' component consists of button-like styled links, that are aligned side by side in a horizontal list.'
        )
      ])
    },
    function() {
      var _vm = this
      var _h = _vm.$createElement
      var _c = _vm._self._c || _h
      return _c('div', { staticClass: 'uk-margin-medium' }, [
        _c('pre', [
          _c('code', { staticClass: 'lang-html hljs' }, [
            _c('span', { staticClass: 'hljs-tag' }, [
              _vm._v('<'),
              _c('span', { staticClass: 'hljs-name' }, [
                _vm._v('vk-pagination')
              ]),
              _vm._v('>')
            ]),
            _vm._v('\n  '),
            _c('span', { staticClass: 'hljs-tag' }, [
              _vm._v('<'),
              _c('span', { staticClass: 'hljs-name' }, [
                _vm._v('vk-pagination-pages')
              ]),
              _vm._v('>')
            ]),
            _c('span', { staticClass: 'hljs-tag' }, [
              _vm._v('</'),
              _c('span', { staticClass: 'hljs-name' }, [
                _vm._v('vk-pagination-pages')
              ]),
              _vm._v('>')
            ]),
            _vm._v('\n'),
            _c('span', { staticClass: 'hljs-tag' }, [
              _vm._v('</'),
              _c('span', { staticClass: 'hljs-name' }, [
                _vm._v('vk-pagination')
              ]),
              _vm._v('>')
            ])
          ])
        ])
      ])
    },
    function() {
      var _vm = this
      var _h = _vm.$createElement
      var _c = _vm._self._c || _h
      return _c(
        'h2',
        {
          staticClass: 'uk-h2 tm-heading-fragment',
          attrs: { id: 'alignment' }
        },
        [_c('a', { attrs: { href: '#alignment' } }, [_vm._v('Alignment')])]
      )
    },
    function() {
      var _vm = this
      var _h = _vm.$createElement
      var _c = _vm._self._c || _h
      return _c('p', [
        _vm._v('Use the '),
        _c('code', [_vm._v('align')]),
        _vm._v(' prop to change the pagination alignment to '),
        _c('code', [_vm._v('left')]),
        _vm._v(' or '),
        _c('code', [_vm._v('right')]),
        _vm._v('.')
      ])
    },
    function() {
      var _vm = this
      var _h = _vm.$createElement
      var _c = _vm._self._c || _h
      return _c('div', { staticClass: 'uk-margin-medium' }, [
        _c('pre', [
          _c('code', { staticClass: 'lang-html hljs' }, [
            _c('span', { staticClass: 'hljs-tag' }, [
              _vm._v('<'),
              _c('span', { staticClass: 'hljs-name' }, [
                _vm._v('vk-pagination')
              ]),
              _vm._v(' '),
              _c('span', { staticClass: 'hljs-attr' }, [_vm._v('align')]),
              _vm._v('='),
              _c('span', { staticClass: 'hljs-string' }, [_vm._v('"left"')]),
              _vm._v('>')
            ]),
            _vm._v('...'),
            _c('span', { staticClass: 'hljs-tag' }, [
              _vm._v('</'),
              _c('span', { staticClass: 'hljs-name' }, [
                _vm._v('vk-pagination')
              ]),
              _vm._v('>')
            ]),
            _vm._v('\n'),
            _c('span', { staticClass: 'hljs-tag' }, [
              _vm._v('<'),
              _c('span', { staticClass: 'hljs-name' }, [
                _vm._v('vk-pagination')
              ]),
              _vm._v(' '),
              _c('span', { staticClass: 'hljs-attr' }, [_vm._v('align')]),
              _vm._v('='),
              _c('span', { staticClass: 'hljs-string' }, [_vm._v('"right"')]),
              _vm._v('>')
            ]),
            _vm._v('...'),
            _c('span', { staticClass: 'hljs-tag' }, [
              _vm._v('</'),
              _c('span', { staticClass: 'hljs-name' }, [
                _vm._v('vk-pagination')
              ]),
              _vm._v('>')
            ])
          ])
        ])
      ])
    },
    function() {
      var _vm = this
      var _h = _vm.$createElement
      var _c = _vm._self._c || _h
      return _c(
        'h2',
        {
          staticClass: 'uk-h2 tm-heading-fragment',
          attrs: { id: 'page-control' }
        },
        [
          _c('a', { attrs: { href: '#page-control' } }, [
            _vm._v('Page control')
          ])
        ]
      )
    },
    function() {
      var _vm = this
      var _h = _vm.$createElement
      var _c = _vm._self._c || _h
      return _c('p', [
        _vm._v('Set one of the '),
        _c('code', [_vm._v('vk-pagination-page-*')]),
        _vm._v(' components inside '),
        _c('code', [_vm._v('vk-pagination')]),
        _vm._v(' to display the page control buttons.')
      ])
    },
    function() {
      var _vm = this
      var _h = _vm.$createElement
      var _c = _vm._self._c || _h
      return _c('div', { staticClass: 'uk-overflow-auto' }, [
        _c('table', { staticClass: 'uk-table uk-table-divider' }, [
          _c('thead', [
            _c('tr', [
              _c('th', [_vm._v('Component')]),
              _vm._v(' '),
              _c('th', [_vm._v('Description')])
            ])
          ]),
          _vm._v(' '),
          _c('tbody', [
            _c('tr', [
              _c('td', [_c('code', [_vm._v('vk-pagination-page-first')])]),
              _vm._v(' '),
              _c('td', [_vm._v('Displays a go to first page button.')])
            ]),
            _vm._v(' '),
            _c('tr', [
              _c('td', [_c('code', [_vm._v('vk-pagination-page-last')])]),
              _vm._v(' '),
              _c('td', [_vm._v('Displays a go to last page button.')])
            ]),
            _vm._v(' '),
            _c('tr', [
              _c('td', [_c('code', [_vm._v('vk-pagination-page-prev')])]),
              _vm._v(' '),
              _c('td', [_vm._v('Displays a go to previous page button.')])
            ]),
            _vm._v(' '),
            _c('tr', [
              _c('td', [_c('code', [_vm._v('vk-pagination-page-next')])]),
              _vm._v(' '),
              _c('td', [_vm._v('Displays a go to next page button.')])
            ])
          ])
        ])
      ])
    },
    function() {
      var _vm = this
      var _h = _vm.$createElement
      var _c = _vm._self._c || _h
      return _c('div', { staticClass: 'uk-margin-medium' }, [
        _c('pre', [
          _c('code', { staticClass: 'lang-html hljs' }, [
            _c('span', { staticClass: 'hljs-tag' }, [
              _vm._v('<'),
              _c('span', { staticClass: 'hljs-name' }, [
                _vm._v('vk-pagination')
              ]),
              _vm._v('>')
            ]),
            _vm._v('\n  '),
            _c('span', { staticClass: 'hljs-tag' }, [
              _vm._v('<'),
              _c('span', { staticClass: 'hljs-name' }, [
                _vm._v('vk-pagination-page-first')
              ]),
              _vm._v('>')
            ]),
            _c('span', { staticClass: 'hljs-tag' }, [
              _vm._v('</'),
              _c('span', { staticClass: 'hljs-name' }, [
                _vm._v('vk-pagination-page-first')
              ]),
              _vm._v('>')
            ]),
            _vm._v('\n  '),
            _c('span', { staticClass: 'hljs-tag' }, [
              _vm._v('<'),
              _c('span', { staticClass: 'hljs-name' }, [
                _vm._v('vk-pagination-page-prev')
              ]),
              _vm._v(' '),
              _c('span', { staticClass: 'hljs-attr' }, [_vm._v('label')]),
              _vm._v('='),
              _c('span', { staticClass: 'hljs-string' }, [
                _vm._v('"Previous"')
              ]),
              _vm._v(' '),
              _c('span', { staticClass: 'hljs-attr' }, [_vm._v('expanded')]),
              _vm._v('>')
            ]),
            _c('span', { staticClass: 'hljs-tag' }, [
              _vm._v('</'),
              _c('span', { staticClass: 'hljs-name' }, [
                _vm._v('vk-pagination-page-prev')
              ]),
              _vm._v('>')
            ]),
            _vm._v('\n  '),
            _c('span', { staticClass: 'hljs-tag' }, [
              _vm._v('<'),
              _c('span', { staticClass: 'hljs-name' }, [
                _vm._v('vk-pagination-page-next')
              ]),
              _vm._v(' '),
              _c('span', { staticClass: 'hljs-attr' }, [_vm._v('label')]),
              _vm._v('='),
              _c('span', { staticClass: 'hljs-string' }, [_vm._v('"Next"')]),
              _vm._v(' '),
              _c('span', { staticClass: 'hljs-attr' }, [_vm._v('expanded')]),
              _vm._v('>')
            ]),
            _c('span', { staticClass: 'hljs-tag' }, [
              _vm._v('</'),
              _c('span', { staticClass: 'hljs-name' }, [
                _vm._v('vk-pagination-page-next')
              ]),
              _vm._v('>')
            ]),
            _vm._v('\n  '),
            _c('span', { staticClass: 'hljs-tag' }, [
              _vm._v('<'),
              _c('span', { staticClass: 'hljs-name' }, [
                _vm._v('vk-pagination-page-last')
              ]),
              _vm._v('>')
            ]),
            _c('span', { staticClass: 'hljs-tag' }, [
              _vm._v('</'),
              _c('span', { staticClass: 'hljs-name' }, [
                _vm._v('vk-pagination-page-last')
              ]),
              _vm._v('>')
            ]),
            _vm._v('\n'),
            _c('span', { staticClass: 'hljs-tag' }, [
              _vm._v('</'),
              _c('span', { staticClass: 'hljs-name' }, [
                _vm._v('vk-pagination')
              ]),
              _vm._v('>')
            ])
          ])
        ])
      ])
    },
    function() {
      var _vm = this
      var _h = _vm.$createElement
      var _c = _vm._self._c || _h
      return _c(
        'h2',
        { staticClass: 'uk-h2 tm-heading-fragment', attrs: { id: 'props' } },
        [_c('a', { attrs: { href: '#props' } }, [_vm._v('Props')])]
      )
    },
    function() {
      var _vm = this
      var _h = _vm.$createElement
      var _c = _vm._self._c || _h
      return _c(
        'h3',
        {
          staticClass: 'uk-h3 tm-heading-fragment',
          attrs: { id: 'vk-pagination' }
        },
        [
          _c('a', { attrs: { href: '#vk-pagination' } }, [
            _vm._v('vk-pagination')
          ])
        ]
      )
    },
    function() {
      var _vm = this
      var _h = _vm.$createElement
      var _c = _vm._self._c || _h
      return _c('div', { staticClass: 'uk-overflow-auto' }, [
        _c('table', { staticClass: 'uk-table uk-table-divider' }, [
          _c('thead', [
            _c('tr', [
              _c('th', [_vm._v('Name')]),
              _vm._v(' '),
              _c('th', [_vm._v('Type')]),
              _vm._v(' '),
              _c('th', [_vm._v('Default')]),
              _vm._v(' '),
              _c('th', [_vm._v('Description')])
            ])
          ]),
          _vm._v(' '),
          _c('tbody', [
            _c('tr', [
              _c('td', [_c('code', [_vm._v('page')])]),
              _vm._v(' '),
              _c('td', [_vm._v('Number')]),
              _vm._v(' '),
              _c('td', [_c('code', [_vm._v('1')])]),
              _vm._v(' '),
              _c('td', [_vm._v('The currently displayed page.')])
            ]),
            _vm._v(' '),
            _c('tr', [
              _c('td', [_c('code', [_vm._v('perPage')])]),
              _vm._v(' '),
              _c('td', [_vm._v('Number')]),
              _vm._v(' '),
              _c('td', [_vm._v('--')]),
              _vm._v(' '),
              _c('td', [_vm._v('The amount of items displayed per page.')])
            ]),
            _vm._v(' '),
            _c('tr', [
              _c('td', [_c('code', [_vm._v('total')])]),
              _vm._v(' '),
              _c('td', [_vm._v('Number')]),
              _vm._v(' '),
              _c('td', [_vm._v('--')]),
              _vm._v(' '),
              _c('td', [_vm._v('The total amount of items across all pages.')])
            ]),
            _vm._v(' '),
            _c('tr', [
              _c('td', [_c('code', [_vm._v('range')])]),
              _vm._v(' '),
              _c('td', [_vm._v('Number')]),
              _vm._v(' '),
              _c('td', [_c('code', [_vm._v('3')])]),
              _vm._v(' '),
              _c('td', [
                _vm._v(
                  'The range of pages to show before hiding the rest when the total of pages exceeds the layout.'
                )
              ])
            ]),
            _vm._v(' '),
            _c('tr', [
              _c('td', [_c('code', [_vm._v('align')])]),
              _vm._v(' '),
              _c('td', [_vm._v('String')]),
              _vm._v(' '),
              _c('td', [_c('code', [_vm._v('left')])]),
              _vm._v(' '),
              _c('td', [
                _vm._v('The pagination alignment, '),
                _c('code', [_vm._v('left')]),
                _vm._v(', '),
                _c('code', [_vm._v('center')]),
                _vm._v(' or '),
                _c('code', [_vm._v('right')]),
                _vm._v('.')
              ])
            ])
          ])
        ])
      ])
    },
    function() {
      var _vm = this
      var _h = _vm.$createElement
      var _c = _vm._self._c || _h
      return _c(
        'h3',
        {
          staticClass: 'uk-h3 tm-heading-fragment',
          attrs: { id: 'vk-pagination-page-' }
        },
        [
          _c('a', { attrs: { href: '#vk-pagination-page-' } }, [
            _vm._v('vk-pagination-page-*')
          ])
        ]
      )
    },
    function() {
      var _vm = this
      var _h = _vm.$createElement
      var _c = _vm._self._c || _h
      return _c('div', { staticClass: 'uk-overflow-auto' }, [
        _c('table', { staticClass: 'uk-table uk-table-divider' }, [
          _c('thead', [
            _c('tr', [
              _c('th', [_vm._v('Name')]),
              _vm._v(' '),
              _c('th', [_vm._v('Type')]),
              _vm._v(' '),
              _c('th', [_vm._v('Default')]),
              _vm._v(' '),
              _c('th', [_vm._v('Description')])
            ])
          ]),
          _vm._v(' '),
          _c('tbody', [
            _c('tr', [
              _c('td', [_c('code', [_vm._v('label')])]),
              _vm._v(' '),
              _c('td', [_vm._v('String')]),
              _vm._v(' '),
              _c('td', [_vm._v('--')]),
              _vm._v(' '),
              _c('td', [_vm._v('The button optional label.')])
            ]),
            _vm._v(' '),
            _c('tr', [
              _c('td', [_c('code', [_vm._v('disabled')])]),
              _vm._v(' '),
              _c('td', [_vm._v('Boolean')]),
              _vm._v(' '),
              _c('td', [_vm._v('false')]),
              _vm._v(' '),
              _c('td', [_vm._v('Disables the page.')])
            ]),
            _vm._v(' '),
            _c('tr', [
              _c('td', [_c('code', [_vm._v('expanded')])]),
              _vm._v(' '),
              _c('td', [_vm._v('Boolean')]),
              _vm._v(' '),
              _c('td', [_vm._v('false')]),
              _vm._v(' '),
              _c('td', [
                _vm._v('Expands the button taking all the left space.')
              ])
            ])
          ])
        ])
      ])
    }
  ],
  data: function() {
    return {}
  },
  scrollToTop: true,
  sections: [
    { id: 'usage', title: 'Usage' },
    { id: 'alignment', title: 'Alignment' },
    { id: 'page-control', title: 'Page control' },
    { id: 'props', title: 'Props' }
  ],
  components: {
    'md-code-example-87': {
      render: function render() {
        var _vm = this
        var _h = _vm.$createElement
        var _c = _vm._self._c || _h
        return _c(
          'div',
          { staticClass: 'uk-position-relative uk-margin-medium' },
          [
            _c(
              'vk-tabs',
              { staticClass: 'uk-margin' },
              [
                _c(
                  'vk-tabs-item',
                  { attrs: { title: 'Preview' } },
                  [
                    _c(
                      'vk-pagination',
                      {
                        attrs: { page: _vm.page, perPage: 10, total: 200 },
                        on: {
                          'update:page': function($event) {
                            _vm.page = $event
                          }
                        }
                      },
                      [
                        _c('vk-pagination-page-prev'),
                        _vm._v(' '),
                        _c('vk-pagination-pages'),
                        _vm._v(' '),
                        _c('vk-pagination-page-next')
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(' '),
                _c('vk-tabs-item', { attrs: { title: 'Markup' } }, [
                  _c('pre', [
                    _c(
                      'code',
                      { staticClass: 'lang-html hljs', attrs: { id: '87' } },
                      [
                        _vm._v('---\npage: 7\n---\n\n'),
                        _c('span', { staticClass: 'hljs-tag' }, [
                          _vm._v('<'),
                          _c('span', { staticClass: 'hljs-name' }, [
                            _vm._v('vk-pagination')
                          ]),
                          _vm._v(' '),
                          _c('span', { staticClass: 'hljs-attr' }, [
                            _vm._v(':page.sync')
                          ]),
                          _vm._v('='),
                          _c('span', { staticClass: 'hljs-string' }, [
                            _vm._v('"page"')
                          ]),
                          _vm._v(' '),
                          _c('span', { staticClass: 'hljs-attr' }, [
                            _vm._v(':perPage')
                          ]),
                          _vm._v('='),
                          _c('span', { staticClass: 'hljs-string' }, [
                            _vm._v('"10"')
                          ]),
                          _vm._v(' '),
                          _c('span', { staticClass: 'hljs-attr' }, [
                            _vm._v(':total')
                          ]),
                          _vm._v('='),
                          _c('span', { staticClass: 'hljs-string' }, [
                            _vm._v('"200"')
                          ]),
                          _vm._v('>')
                        ]),
                        _vm._v('\n  '),
                        _c('span', { staticClass: 'hljs-tag' }, [
                          _vm._v('<'),
                          _c('span', { staticClass: 'hljs-name' }, [
                            _vm._v('vk-pagination-page-prev')
                          ]),
                          _vm._v('>')
                        ]),
                        _c('span', { staticClass: 'hljs-tag' }, [
                          _vm._v('</'),
                          _c('span', { staticClass: 'hljs-name' }, [
                            _vm._v('vk-pagination-page-prev')
                          ]),
                          _vm._v('>')
                        ]),
                        _vm._v('\n  '),
                        _c('span', { staticClass: 'hljs-tag' }, [
                          _vm._v('<'),
                          _c('span', { staticClass: 'hljs-name' }, [
                            _vm._v('vk-pagination-pages')
                          ]),
                          _vm._v('>')
                        ]),
                        _c('span', { staticClass: 'hljs-tag' }, [
                          _vm._v('</'),
                          _c('span', { staticClass: 'hljs-name' }, [
                            _vm._v('vk-pagination-pages')
                          ]),
                          _vm._v('>')
                        ]),
                        _vm._v('\n  '),
                        _c('span', { staticClass: 'hljs-tag' }, [
                          _vm._v('<'),
                          _c('span', { staticClass: 'hljs-name' }, [
                            _vm._v('vk-pagination-page-next')
                          ]),
                          _vm._v('>')
                        ]),
                        _c('span', { staticClass: 'hljs-tag' }, [
                          _vm._v('</'),
                          _c('span', { staticClass: 'hljs-name' }, [
                            _vm._v('vk-pagination-page-next')
                          ]),
                          _vm._v('>')
                        ]),
                        _vm._v('\n'),
                        _c('span', { staticClass: 'hljs-tag' }, [
                          _vm._v('</'),
                          _c('span', { staticClass: 'hljs-name' }, [
                            _vm._v('vk-pagination')
                          ]),
                          _vm._v('>')
                        ])
                      ]
                    )
                  ])
                ])
              ],
              1
            )
          ],
          1
        )
      },
      data: function() {
        return { page: 7 }
      }
    },
    'md-code-example-88': {
      render: function render() {
        var _vm = this
        var _h = _vm.$createElement
        var _c = _vm._self._c || _h
        return _c(
          'div',
          { staticClass: 'uk-position-relative uk-margin-medium' },
          [
            _c(
              'vk-tabs',
              { staticClass: 'uk-margin' },
              [
                _c(
                  'vk-tabs-item',
                  { attrs: { title: 'Preview' } },
                  [
                    _c(
                      'vk-pagination',
                      {
                        attrs: {
                          align: 'left',
                          page: _vm.page,
                          perPage: 10,
                          total: 100
                        },
                        on: {
                          'update:page': function($event) {
                            _vm.page = $event
                          }
                        }
                      },
                      [
                        _c('vk-pagination-page-prev'),
                        _vm._v(' '),
                        _c('vk-pagination-pages'),
                        _vm._v(' '),
                        _c('vk-pagination-page-next')
                      ],
                      1
                    ),
                    _vm._v(' '),
                    _c(
                      'vk-pagination',
                      {
                        attrs: {
                          align: 'right',
                          page: _vm.page,
                          perPage: 10,
                          total: 100
                        },
                        on: {
                          'update:page': function($event) {
                            _vm.page = $event
                          }
                        }
                      },
                      [
                        _c('vk-pagination-page-prev'),
                        _vm._v(' '),
                        _c('vk-pagination-pages'),
                        _vm._v(' '),
                        _c('vk-pagination-page-next')
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(' '),
                _c('vk-tabs-item', { attrs: { title: 'Markup' } }, [
                  _c('pre', [
                    _c(
                      'code',
                      { staticClass: 'lang-html hljs', attrs: { id: '88' } },
                      [
                        _vm._v('---\npage: 7\n---\n\n'),
                        _c('span', { staticClass: 'hljs-tag' }, [
                          _vm._v('<'),
                          _c('span', { staticClass: 'hljs-name' }, [
                            _vm._v('vk-pagination')
                          ]),
                          _vm._v(' '),
                          _c('span', { staticClass: 'hljs-attr' }, [
                            _vm._v('align')
                          ]),
                          _vm._v('='),
                          _c('span', { staticClass: 'hljs-string' }, [
                            _vm._v('"left"')
                          ]),
                          _vm._v(' '),
                          _c('span', { staticClass: 'hljs-attr' }, [
                            _vm._v(':page.sync')
                          ]),
                          _vm._v('='),
                          _c('span', { staticClass: 'hljs-string' }, [
                            _vm._v('"page"')
                          ]),
                          _vm._v(' '),
                          _c('span', { staticClass: 'hljs-attr' }, [
                            _vm._v(':perPage')
                          ]),
                          _vm._v('='),
                          _c('span', { staticClass: 'hljs-string' }, [
                            _vm._v('"10"')
                          ]),
                          _vm._v(' '),
                          _c('span', { staticClass: 'hljs-attr' }, [
                            _vm._v(':total')
                          ]),
                          _vm._v('='),
                          _c('span', { staticClass: 'hljs-string' }, [
                            _vm._v('"100"')
                          ]),
                          _vm._v('>')
                        ]),
                        _vm._v('\n  '),
                        _c('span', { staticClass: 'hljs-tag' }, [
                          _vm._v('<'),
                          _c('span', { staticClass: 'hljs-name' }, [
                            _vm._v('vk-pagination-page-prev')
                          ]),
                          _vm._v('>')
                        ]),
                        _c('span', { staticClass: 'hljs-tag' }, [
                          _vm._v('</'),
                          _c('span', { staticClass: 'hljs-name' }, [
                            _vm._v('vk-pagination-page-prev')
                          ]),
                          _vm._v('>')
                        ]),
                        _vm._v('\n  '),
                        _c('span', { staticClass: 'hljs-tag' }, [
                          _vm._v('<'),
                          _c('span', { staticClass: 'hljs-name' }, [
                            _vm._v('vk-pagination-pages')
                          ]),
                          _vm._v('>')
                        ]),
                        _c('span', { staticClass: 'hljs-tag' }, [
                          _vm._v('</'),
                          _c('span', { staticClass: 'hljs-name' }, [
                            _vm._v('vk-pagination-pages')
                          ]),
                          _vm._v('>')
                        ]),
                        _vm._v('\n  '),
                        _c('span', { staticClass: 'hljs-tag' }, [
                          _vm._v('<'),
                          _c('span', { staticClass: 'hljs-name' }, [
                            _vm._v('vk-pagination-page-next')
                          ]),
                          _vm._v('>')
                        ]),
                        _c('span', { staticClass: 'hljs-tag' }, [
                          _vm._v('</'),
                          _c('span', { staticClass: 'hljs-name' }, [
                            _vm._v('vk-pagination-page-next')
                          ]),
                          _vm._v('>')
                        ]),
                        _vm._v('\n'),
                        _c('span', { staticClass: 'hljs-tag' }, [
                          _vm._v('</'),
                          _c('span', { staticClass: 'hljs-name' }, [
                            _vm._v('vk-pagination')
                          ]),
                          _vm._v('>')
                        ]),
                        _vm._v('\n\n'),
                        _c('span', { staticClass: 'hljs-tag' }, [
                          _vm._v('<'),
                          _c('span', { staticClass: 'hljs-name' }, [
                            _vm._v('vk-pagination')
                          ]),
                          _vm._v(' '),
                          _c('span', { staticClass: 'hljs-attr' }, [
                            _vm._v('align')
                          ]),
                          _vm._v('='),
                          _c('span', { staticClass: 'hljs-string' }, [
                            _vm._v('"right"')
                          ]),
                          _vm._v(' '),
                          _c('span', { staticClass: 'hljs-attr' }, [
                            _vm._v(':page.sync')
                          ]),
                          _vm._v('='),
                          _c('span', { staticClass: 'hljs-string' }, [
                            _vm._v('"page"')
                          ]),
                          _vm._v(' '),
                          _c('span', { staticClass: 'hljs-attr' }, [
                            _vm._v(':perPage')
                          ]),
                          _vm._v('='),
                          _c('span', { staticClass: 'hljs-string' }, [
                            _vm._v('"10"')
                          ]),
                          _vm._v(' '),
                          _c('span', { staticClass: 'hljs-attr' }, [
                            _vm._v(':total')
                          ]),
                          _vm._v('='),
                          _c('span', { staticClass: 'hljs-string' }, [
                            _vm._v('"100"')
                          ]),
                          _vm._v('>')
                        ]),
                        _vm._v('\n  '),
                        _c('span', { staticClass: 'hljs-tag' }, [
                          _vm._v('<'),
                          _c('span', { staticClass: 'hljs-name' }, [
                            _vm._v('vk-pagination-page-prev')
                          ]),
                          _vm._v('>')
                        ]),
                        _c('span', { staticClass: 'hljs-tag' }, [
                          _vm._v('</'),
                          _c('span', { staticClass: 'hljs-name' }, [
                            _vm._v('vk-pagination-page-prev')
                          ]),
                          _vm._v('>')
                        ]),
                        _vm._v('\n  '),
                        _c('span', { staticClass: 'hljs-tag' }, [
                          _vm._v('<'),
                          _c('span', { staticClass: 'hljs-name' }, [
                            _vm._v('vk-pagination-pages')
                          ]),
                          _vm._v('>')
                        ]),
                        _c('span', { staticClass: 'hljs-tag' }, [
                          _vm._v('</'),
                          _c('span', { staticClass: 'hljs-name' }, [
                            _vm._v('vk-pagination-pages')
                          ]),
                          _vm._v('>')
                        ]),
                        _vm._v('\n  '),
                        _c('span', { staticClass: 'hljs-tag' }, [
                          _vm._v('<'),
                          _c('span', { staticClass: 'hljs-name' }, [
                            _vm._v('vk-pagination-page-next')
                          ]),
                          _vm._v('>')
                        ]),
                        _c('span', { staticClass: 'hljs-tag' }, [
                          _vm._v('</'),
                          _c('span', { staticClass: 'hljs-name' }, [
                            _vm._v('vk-pagination-page-next')
                          ]),
                          _vm._v('>')
                        ]),
                        _vm._v('\n'),
                        _c('span', { staticClass: 'hljs-tag' }, [
                          _vm._v('</'),
                          _c('span', { staticClass: 'hljs-name' }, [
                            _vm._v('vk-pagination')
                          ]),
                          _vm._v('>')
                        ])
                      ]
                    )
                  ])
                ])
              ],
              1
            )
          ],
          1
        )
      },
      data: function() {
        return { page: 7 }
      }
    },
    'md-code-example-89': {
      render: function render() {
        var _vm = this
        var _h = _vm.$createElement
        var _c = _vm._self._c || _h
        return _c(
          'div',
          { staticClass: 'uk-position-relative uk-margin-medium' },
          [
            _c(
              'vk-tabs',
              { staticClass: 'uk-margin' },
              [
                _c(
                  'vk-tabs-item',
                  { attrs: { title: 'Preview' } },
                  [
                    _c(
                      'vk-pagination',
                      {
                        attrs: { page: _vm.page, 'per-page': 50, total: 200 },
                        on: {
                          'update:page': function($event) {
                            _vm.page = $event
                          }
                        }
                      },
                      [
                        _c('vk-pagination-page-first'),
                        _vm._v(' '),
                        _c('vk-pagination-page-prev', {
                          attrs: { label: 'Previous', expanded: '' }
                        }),
                        _vm._v(' '),
                        _c('vk-pagination-pages'),
                        _vm._v(' '),
                        _c('vk-pagination-page-next', {
                          attrs: { label: 'Next', expanded: '' }
                        }),
                        _vm._v(' '),
                        _c('vk-pagination-page-last')
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(' '),
                _c('vk-tabs-item', { attrs: { title: 'Markup' } }, [
                  _c('pre', [
                    _c(
                      'code',
                      { staticClass: 'lang-html hljs', attrs: { id: '89' } },
                      [
                        _vm._v('---\npage: 1\n---\n\n'),
                        _c('span', { staticClass: 'hljs-tag' }, [
                          _vm._v('<'),
                          _c('span', { staticClass: 'hljs-name' }, [
                            _vm._v('vk-pagination')
                          ]),
                          _vm._v(' '),
                          _c('span', { staticClass: 'hljs-attr' }, [
                            _vm._v(':page.sync')
                          ]),
                          _vm._v('='),
                          _c('span', { staticClass: 'hljs-string' }, [
                            _vm._v('"page"')
                          ]),
                          _vm._v(' '),
                          _c('span', { staticClass: 'hljs-attr' }, [
                            _vm._v(':per-page')
                          ]),
                          _vm._v('='),
                          _c('span', { staticClass: 'hljs-string' }, [
                            _vm._v('"50"')
                          ]),
                          _vm._v(' '),
                          _c('span', { staticClass: 'hljs-attr' }, [
                            _vm._v(':total')
                          ]),
                          _vm._v('='),
                          _c('span', { staticClass: 'hljs-string' }, [
                            _vm._v('"200"')
                          ]),
                          _vm._v('>')
                        ]),
                        _vm._v('\n  '),
                        _c('span', { staticClass: 'hljs-tag' }, [
                          _vm._v('<'),
                          _c('span', { staticClass: 'hljs-name' }, [
                            _vm._v('vk-pagination-page-first')
                          ]),
                          _vm._v('>')
                        ]),
                        _c('span', { staticClass: 'hljs-tag' }, [
                          _vm._v('</'),
                          _c('span', { staticClass: 'hljs-name' }, [
                            _vm._v('vk-pagination-page-first')
                          ]),
                          _vm._v('>')
                        ]),
                        _vm._v('\n  '),
                        _c('span', { staticClass: 'hljs-tag' }, [
                          _vm._v('<'),
                          _c('span', { staticClass: 'hljs-name' }, [
                            _vm._v('vk-pagination-page-prev')
                          ]),
                          _vm._v(' '),
                          _c('span', { staticClass: 'hljs-attr' }, [
                            _vm._v('label')
                          ]),
                          _vm._v('='),
                          _c('span', { staticClass: 'hljs-string' }, [
                            _vm._v('"Previous"')
                          ]),
                          _vm._v(' '),
                          _c('span', { staticClass: 'hljs-attr' }, [
                            _vm._v('expanded')
                          ]),
                          _vm._v('>')
                        ]),
                        _c('span', { staticClass: 'hljs-tag' }, [
                          _vm._v('</'),
                          _c('span', { staticClass: 'hljs-name' }, [
                            _vm._v('vk-pagination-page-prev')
                          ]),
                          _vm._v('>')
                        ]),
                        _vm._v('\n  '),
                        _c('span', { staticClass: 'hljs-tag' }, [
                          _vm._v('<'),
                          _c('span', { staticClass: 'hljs-name' }, [
                            _vm._v('vk-pagination-pages')
                          ]),
                          _vm._v('>')
                        ]),
                        _c('span', { staticClass: 'hljs-tag' }, [
                          _vm._v('</'),
                          _c('span', { staticClass: 'hljs-name' }, [
                            _vm._v('vk-pagination-pages')
                          ]),
                          _vm._v('>')
                        ]),
                        _vm._v('\n  '),
                        _c('span', { staticClass: 'hljs-tag' }, [
                          _vm._v('<'),
                          _c('span', { staticClass: 'hljs-name' }, [
                            _vm._v('vk-pagination-page-next')
                          ]),
                          _vm._v(' '),
                          _c('span', { staticClass: 'hljs-attr' }, [
                            _vm._v('label')
                          ]),
                          _vm._v('='),
                          _c('span', { staticClass: 'hljs-string' }, [
                            _vm._v('"Next"')
                          ]),
                          _vm._v(' '),
                          _c('span', { staticClass: 'hljs-attr' }, [
                            _vm._v('expanded')
                          ]),
                          _vm._v('>')
                        ]),
                        _c('span', { staticClass: 'hljs-tag' }, [
                          _vm._v('</'),
                          _c('span', { staticClass: 'hljs-name' }, [
                            _vm._v('vk-pagination-page-next')
                          ]),
                          _vm._v('>')
                        ]),
                        _vm._v('\n  '),
                        _c('span', { staticClass: 'hljs-tag' }, [
                          _vm._v('<'),
                          _c('span', { staticClass: 'hljs-name' }, [
                            _vm._v('vk-pagination-page-last')
                          ]),
                          _vm._v('>')
                        ]),
                        _c('span', { staticClass: 'hljs-tag' }, [
                          _vm._v('</'),
                          _c('span', { staticClass: 'hljs-name' }, [
                            _vm._v('vk-pagination-page-last')
                          ]),
                          _vm._v('>')
                        ]),
                        _vm._v('\n'),
                        _c('span', { staticClass: 'hljs-tag' }, [
                          _vm._v('</'),
                          _c('span', { staticClass: 'hljs-name' }, [
                            _vm._v('vk-pagination')
                          ]),
                          _vm._v('>')
                        ])
                      ]
                    )
                  ])
                ])
              ],
              1
            )
          ],
          1
        )
      },
      data: function() {
        return { page: 1 }
      }
    }
  }
}


export default Component
